



















































import VueOptions from '@utils/VueOptions'
import UiList from '@superUI/List/List'
import Modal from '@/components/Modal'
import Trigger from '@modules/ui/triggers/Trigger'
import ResourceList from '@modules/ui/List/ResourceList'
import LoadingIndicator from '@/components/LoadingIndicator'

settings =
  name: 'ShoppingCartResourceList'

  vue:
    props: ['shoppingCarts', 'bulkActionResultItems', 'actions', 'filtersOverriden', 'infiniteWrapper', 'options']
    components: {
      UiList,
      Modal,
      Trigger,
      ResourceList,
      LoadingIndicator
    }

    data: ->
      activeFilter: false
      pageNumber: 1

      filters:
        scopes: {}
        q: ''

      selectedFilters: []
      selectedShoppingCarts: []
      rowSize: 3

    mounted: ->
      @filters = @filtersOverriden if @filtersOverriden?

    computed:
      components: ->
        {
          'shopping-cart-resource-list-item': () => import('./ShoppingCartResourceListItem')
        }
      title: ->
        @options?.title || 'Shopping Carts'

      resourceKey: ->
        @options?.resourceKey || 'shopping_carts'

    methods:
      hiInfiniteScroll: (state) ->
        @actions.fetchResource(state, @resourceKey, @formatFiltersPayload(), { page: @pageNumber })
        @pageNumber += 1

      hiFilterChange: (selectedFilters) ->
        @$refs.infiniteLoading.stateChanger.reset()
        @selectedFilters = selectedFilters if selectedFilters
        @pageNumber = 1
        filtersPayload = @formatFiltersPayload()
        @actions.fetchResource(null, @resourceKey, filtersPayload, { page: @pageNumber })
        @pageNumber += 1

      formatFiltersPayload: ->
        payload = {...@filters}
        timeWindows = payload.time_windows

        payload.filters = payload.filters || {}
        for field, timeWindow of timeWindows
          payload.filters["#{field}_before"] = timeWindow.before if timeWindow.before
          payload.filters["#{field}_after"] = timeWindow.after if timeWindow.after

        payload

      hiSearchChange: (q = '') ->
        @filters.q = q
        @hiFilterChange(@filters)

      hiClearFilter: ->
        cleared_filter_scope = @filters.scopes
        Object.keys(cleared_filter_scope).forEach((key) -> cleared_filter_scope[key] = null)
        @selectedFilters = []
        @hiFilterChange(@filters)

export default VueOptions.vue settings
